module.exports = __webpack_public_path__ + "static/media/grid.78a04282.svg";